import * as React from "react";
const SvgUp = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4.99999 16.5L12.5 5L20 16.5L4.99999 16.5Z", stroke: "#18191F", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgUp;
